import * as React from "react";
import {
  Box,
  Grid,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from "@mui/material";
import Add from "@mui/icons-material/Add";
import Minimize from "@mui/icons-material/Minimize";
import * as styles from "./faq.module.css";


const FAQ = ({ node, index }) => {
  const { question, answer } = node;
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <Box mb={2}>
      <Grid container>
        <Grid item xs={12}>
          <Accordion
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
          >
            <AccordionSummary
              aria-controls="panel1a-content"
              id="panel1a-header"
              expandIcon={expanded === `panel${index}` ? <Minimize /> : <Add />}
              className={styles.faqSummary}
            >
              <Typography className={styles.faqQuestion}>{question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                className={styles.faqAnswer}
                dangerouslySetInnerHTML={{ __html: answer }}
              />
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FAQ;
